import { gql } from '@apollo/client';

export const GET_TRAINING = gql`
  query GetTrainingFilter($filters: TrainingFilterInput) {
  getTrainingFilter(filters: $filters) {
    success
    message
    data {
      ARCIMEDES_ROW_ID
      NAME
      PARENT_SLUG
      DELETED
      INDEX
      VIDEO_LINK
      PHOTO
      SLUG
      IMAGEPATH
    }
    error
  }
}
`;

export const GET_TRAINING_CONTENT = gql`
 query GetTrainingContentFilter($filters: TrainingContentFilterInput) {
  getTrainingContentFilter(filters: $filters) {
    success
    message
    data {
      ARCIMEDES_ROW_ID
      CONTENT
      CHAPTER_SLUG
      DELETED
      PHOTO
    }
    error
  }
}
`;